import * as React from "react";

import "./App/App.css";

import TitleBar from "./Bar";

import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import blue from "@material-ui/core/colors/blue";
import Dashboard from "./Dashboard";

import Response from "src/models/response";
import IndexClient from "src/sdk/client";

const theme = createMuiTheme({
  palette: {
    primary: blue
  }
});

export interface IState {
  offset: number;
  query: string;
  facets: any;
  filters: any;
  response: Response;
}

class Home extends React.Component<any, IState> {
  private sdk: IndexClient;

  constructor(props: any) {
    super(props);
    this.sdk = new IndexClient();

    this.state = {
      facets: {},
      filters: {},
      offset: 0,
      query: "",
      response: new Response([], 0, 0, {})
    };

    this.addFilter = this.addFilter.bind(this);
    this.removeFilter = this.removeFilter.bind(this);

    this.generateQueryAddons = this.generateQueryAddons.bind(this);

    this.query = this.query.bind(this);
    this.resultUpdate = this.resultUpdate.bind(this);
    this.doQuery = this.doQuery.bind(this);
  }

  public render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <TitleBar queryFn={this.query} />
          <Dashboard
            addFilter={this.addFilter}
            removeFilter={this.removeFilter}
            lastOffset={this.state.offset}
            facets={this.state.facets}
            results={this.state.response.Results}
            total={this.state.response.Total}
            count={this.state.response.Count}
            queryFn={this.query}
          />
        </div>
      </MuiThemeProvider>
    );
  }

  private addFilter(facetName: string, facetValue: string) {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          [facetName]: [...(this.state.filters[facetName] || []), facetValue]
        }
      },
      () => this.doQuery(false)
    );
  }

  private removeFilter(facetName: string, facetValue: string) {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          [facetName]: [
            ...(this.state.filters[facetName] || []).filter(
              (existingVal: string) => existingVal !== facetValue
            )
          ]
        }
      },
      () => this.doQuery(false)
    );
  }

  private query(query?: string, offset?: number) {
    const updatePatch: any = {};

    if (query !== undefined) {
      updatePatch.query = query;
    }
    if (offset !== undefined) {
      updatePatch.offset = offset;
    }

    this.setState(updatePatch, () => this.doQuery(true));
  }

  private generateQueryAddons(): string {
    const facetKeys = Object.keys(this.state.filters);
    const filters = [];

    for (const facetKey of facetKeys) {
      if (this.state.filters[facetKey].length > 0) {
        const items = this.state.filters[facetKey].map(
          (facetVal: string) => `@${facetKey}=${facetVal}`
        );
        if (items.length === 1) {
          filters.push(items[0]);
        } else {
          filters.push(`(or ${items.join(" ")})`);
        }
      }
    }

    if (filters.length === 0) {
      return "";
    } else if (filters.length === 1) {
      return filters[0];
    }
    return `(and ${filters.join(" ")})`;
  }

  private doQuery(updateFacets: boolean) {
    const queryAddon = this.generateQueryAddons();
    const query = this.state.query + " " + queryAddon;

    // tslint:disable:no-console
    console.log(query);
    this.sdk.query(query, this.state.offset).then(r => {
      this.resultUpdate(r, updateFacets);
    });
  }

  private resultUpdate(response: Response, updateFacets: boolean) {
    if (updateFacets) {
      this.setState({
        facets: response.FacetValues,
        response
      });
    } else {
      this.setState({
        response
      });
    }
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.tsx